import React from 'react';
import { Button, Typography } from '@material-ui/core';
import { PaymentErrorStyles } from './PymentErrorStyles';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import Utils from '../../helpers/Utils';

const PaymentError = ({agencyLogo}) => {
  const classes = PaymentErrorStyles();
  const history = useHistory();

  const handleRedirect = () => {
    Utils.updateCookieData("payment_failed", false);
    history.push("/user/packages");
  };

  return (
    <div className={classes.root}>
      <div className={classes.header}>
        <img src={agencyLogo} alt="Logo" className={classes.logo} />
      </div>

      <div className={classes.cardContainer}>
        <div className={classes.card}>
          <div className={classes.iconContainer}>

            <img 
              src={`${process.env.REACT_APP_CDN_LINK}assets/images/releases/1.0.0/error_4053013.png`}
              alt="Logo" 
              style={{width:'100%',height:'100%', objectFit: 'contain'}} 
            />
          </div>
          <Typography className={classes.message}>
            There was a problem processing your payment. Please make a payment now to reactivate your account.
          </Typography>

          <Button onClick={handleRedirect} variant="contained" className={classes.button}>
            Reactivate Account
          </Button>
        </div>

        <div style={{ marginTop: '16px', textAlign: 'center' }}>
          <Typography className={classes.footer}>
            Questions? Contact us via live chat or email us at info@meetpluto.io
          </Typography>
        </div>
      </div>
    </div>
  );
};

export default PaymentError;